export const AUTH0_COMMON_CLAIM_NAMESPACE = 'https://sky-common.co.nz';
export const AUTH0_AUDIENCE = 'https://api.sky.co.nz';
export const AUTH0_PROFILE_CLAIM_NAMESPACE = 'https://skygo.co.nz/profiles';
export const AUTH0_ACCOUNT_NUMBER_CLAIM_NAMESPACE = 'https://idm.sky.co.nz/account_number';
export const FAQ_URL = 'http://support.skygo.co.nz/support/home';
export const SENTRY_DSN = 'https://997a70eb85b04ef8a7ca5cbbc29cfe32@sentry.io/1731257';
